import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppFilter } from '../../../../models/app-filter.model';
import { AbItemAssembleia } from "app/abstract/full-pages/assembleia/item-assembleia.abstract";

@Injectable({ providedIn: 'root' })
export class ItemAssembleiaService extends AbItemAssembleia {
    prefixo = 'item_assembleia/';

    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    public salvarAlterarDados(entity: any) {
        return this.save(this.prefixo, entity);
    }

    public getDados(id: any) {
        return this.get(`${this.prefixo}dto/`, id);
    }

    public getDadosByAssembleiaId(id: any) {
        return this.get(`${this.prefixo}assembleia/`, id);
    }

    public getOpsVotoByItemIdId(id: any) {
        return this.get(`item_assembleia_opcao_votos/item/`, id);
    }

    public getDadosByFilter(filter: any) {
        return this.get(`${this.prefixo}assembleia/filter/${filter.encode()}`);
    }

    public deleteDados(id: any) {
        return this.delete(this.prefixo, id);
    }

    public downloadArquivo(itemId: number, assembleiaId: number, nomeArquivo: string) {
        return this.get(`${this.prefixo}arquivo/download/${itemId}/${assembleiaId}/${nomeArquivo}`);
    }

    public downloadAnexo(assembleiaItemId: string, anexoId: number) {
        return this.get(`${this.prefixo}anexo/download/${assembleiaItemId}/${anexoId}`)
    }

    public downloadArquivoItemAssembleiaOpcaoVoto(itemAssembleiaIdOpcaoVoto: number, nomeArquivo: string) {
        return this.get(`item_assembleia_opcao_votos/arquivo/download/${itemAssembleiaIdOpcaoVoto}/${nomeArquivo}`);
    }

    public deleteArquivoItemAssembleiaOpcaoVoto(itemAssembleiaIdOpcaoVoto: number, nomeArquivo: string) {
        return this.delete(`item_assembleia_opcao_votos/delete/download/${itemAssembleiaIdOpcaoVoto}/${nomeArquivo}`, null);
    }

    public getItemAssembleiaComFiltro(filter: AppFilter) {
        return this.get(`${this.prefixo}filter/${filter.encode()}`);
    }

}
